export default "__VITE_ASSET__C2rcgFP1__"